var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSplitTestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 8,
    fill: "#E1EAF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 15.8337H13.4003C12.5337 15.8337 11.667 15.5003 11.067 14.8337L8.66699 12.5003L11.0003 10.167C11.667 9.50033 12.467 9.16699 13.4003 9.16699H18.667",
    stroke: "#537089",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 12.5H4.66699",
    stroke: "#537089",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 7.16699L18.667 9.16699L16.667 11.167",
    stroke: "#537089",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 13.833L18.667 15.833L16.667 17.833",
    stroke: "#537089",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitTestIcon);
export default __webpack_public_path__ + "static/media/split-test-icon.2bb110c49ecc9178f98501ac651c5f1c.svg";
export { ForwardRef as ReactComponent };